// hubs object includes the entry point and urls of each hub that uses this template
const hubs = {
  chorus: 'resources.chorus.ai',
};

const devOptions = {
  shortHubUrl: hubs.chorus, //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: `https://${hubs.chorus}` + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
  cihostFolder: 'chorus-multi', //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true, //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;


// WEBPACK FOOTER //
// ./dev-options.js